<template>
    <DetailWarranty/>
</template>
<script>
import DetailWarranty from 'place/warranty/detailsWarranty.vue'
export default {
    components:{
        DetailWarranty
    }
}
</script>
t